import { LuxTheme, ThemeProvider } from '@lux/ds';
import CustomRouter from './components/custom-router/CustomRouter';
import history from './history';

const BasicSetup: React.FC = ({ children }) => (
  <ThemeProvider theme={LuxTheme}>
    <CustomRouter history={history}>{children}</CustomRouter>
  </ThemeProvider>
);

export default BasicSetup;
